define('gigaset_recurring/classes/bridge',[
	"cartware/components/Logger"
], function(
	Logger
) {

	return {
		orderComplete: function(result) {
			this.invoke("ORDER COMPLETE");

			if (result.Url) {
				window.location.href = result.Url;
			}
		},

		orderFailed: function(message) {
			this.invoke("ORDER FAILED", message);

			if (message.Url) {
				window.location.href = message.Url;
			}
		},

		invoke: function() {
			Logger.debug("Bridge invokation", arguments);
		}
	}

});
